import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, NotifyComponent } from '@agilox/ui';

@Component({
	selector: 'ai-chat-error',
	imports: [TranslatePipe, NotifyComponent, ButtonComponent],
	templateUrl: './ai-chat-error.component.html',
})
export class AiChatErrorComponent {
	retry = output<void>();
}
